import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MenuItem  {
    _originalTypeClassName = "zERP.BO.MenuItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MenuItem.translate = translateService;
}
this.label = null;
this.icon = null;
this.command = null;
this.seperator = false;
this.MenuItemKey = null;
this._key = this.MenuItemKey = 0; 
}

static translate: TranslateService;
_key: any;
label:any;
icon:any;
command:any;
seperator:any;
private _MenuItemKey:any;
get MenuItemKey(): any {
    return this._MenuItemKey;
  }
set MenuItemKey(value: any) {
    this._MenuItemKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MenuItemKey == null || $this.MenuItemKey == 0;
            }


}